import { provideHttpClient, withInterceptors } from '@angular/common/http'

import { authInterceptor } from './auth.interceptor'
import { errorInterceptor } from './error.interceptor'
import { trailingSlashInterceptor } from './trailing-slash.interceptor'

export const provideHttp = () =>
  provideHttpClient(withInterceptors([trailingSlashInterceptor, authInterceptor, errorInterceptor]))
